import React from 'react';
import { Grid, Typography, Stack, styled } from '@mui/material';
import { commonLabels } from '../../utils/CommonLabels';
import KeyMetricsItemError from './KeyMetricsItemError';

const KeyMetricsContainer = styled(Stack)({
	gap: '20px',
	width: '100%',
});

const KeyMetricsItemContainer = styled(Grid)({
	width: '100%',
	gridTemplateColumns: '1fr 1fr 1fr',
	justifyContent: 'space-between',
	marginBottom: '30px',
	borderRadius: '12px',
});

interface KeyMetricsProps {
	triggerSelectedDays: (selectedDay: number, metricsType: string) => void;
	selectedDay: number;
	refreshFn: () => void;
}

export const KeyMetricsError: React.FC<KeyMetricsProps> = ({
	triggerSelectedDays,
	selectedDay,
	refreshFn,
}) => {
	return (
		<KeyMetricsContainer>
			<Typography variant="h1">{commonLabels.keyMetrics}</Typography>
			<KeyMetricsItemContainer container>
				{
					<KeyMetricsItemError
						metricsType={commonLabels.RISKOVERDUE}
						metricsLabelLineOne={commonLabels.comingDue}
						triggerSelectedDays={triggerSelectedDays}
						selectedDay={selectedDay}
						refreshFn={refreshFn}
						status={commonLabels.error}
					/>
				}
				{
					<KeyMetricsItemError
						metricsType={commonLabels.NON_COMPLIANT}
						metricsLabelLineOne={commonLabels.notCompliant}
						triggerSelectedDays={triggerSelectedDays}
						selectedDay={selectedDay}
						refreshFn={refreshFn}
						status={commonLabels.error}
					/>
				}
				{
					<KeyMetricsItemError
						metricsType={commonLabels.metricsTypeMappedInSummit}
						metricsLabelLineOne={commonLabels.mappedIn}
						metricsLabelLineTwo={commonLabels.summitGroup}
						triggerSelectedDays={triggerSelectedDays}
						selectedDay={selectedDay}
						refreshFn={refreshFn}
						status={commonLabels.error}
					/>
				}
			</KeyMetricsItemContainer>
		</KeyMetricsContainer>
	);
};

export default KeyMetricsError;
